<template>
  <v-app id="inspire">
    <v-app-bar app color="indigo darken-4" absolute height="75" fixed>
      <v-toolbar-title class="white--text"
      ><h3>신분증 스캔 프로그램 라이선스 관리</h3>
      </v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer app permanent v-if="isLoggedIn" class="indigo lighten-5">
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar tile
          >
            <v-icon large color="primary"
            >mdi-account-badge
            </v-icon
            >
          </v-list-item-avatar
          >
          <v-list-item-content>
            <v-list-item-title>ID: {{ adminId }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-btn
                style="width: 100%"
                @click="dialog = true"
                v-if="isLoggedIn"
                color="primary"
                tile
            ><h4>로그아웃</h4>
            </v-btn>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-dialog v-model="dialog" max-width="300">
        <v-card>
          <v-card-title class="text-h8"> 로그아웃 하시겠습니까?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small text @click="logout"> 확인</v-btn>
            <v-btn color="primary" small text @click="dialog = false">
              취소
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item-group v-model="selectedItem">
          <v-list-item
              v-for="(item, i) in items"
              :key="item.title"
              @click="navigateTo(item.to, item.title)"
              color="primary"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data: () => ({
    user: null,
    org: null,
    access: false,
    drawer: null,
    dialog: false,
    selectedItem: null,
    items: [
      {
        title: "고객사 등록 및 관리",
        // items: [{ title: "요양기관 정보", to: "/hospital" }],
        to: "/admin/company",
        icon: "mdi-domain",
      },
      // {
      //   title: "고객사 등록 ",
      //   // items: [{ title: "라이선스 관리", to: "/lic" }],
      //   to: "/admin/register",
      //   icon: "mdi-account-plus",
      // },
      {
        title: "프로젝트 등록 및 관리",
        // items: [{ title: "라이선스 관리", to: "/lic" }],
        to: "/admin/project",
        icon: "mdi-account-supervisor-outline",
      },
      {
        title: "라이선스 관리",
        // items: [{ title: "라이선스 관리", to: "/lic" }],
        to: "/admin/license",
        icon: "mdi-card-account-details",
      },
     
    ],
  }),
  computed: {
    ...mapGetters(['isLoggedIn', 'adminId']),
  },
  created() {
  },

  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
      this.dialog = false;
    },
    navigateTo(route, title) {
      if (route === "/admin/license") {
        sessionStorage.removeItem('selectedCompany'); // sessionStorage 값 제거
      }
      this.selectedItem = title; // 선택된 항목 업데이트
      this.$router.push(route); // 지정된 경로로 이동
    },
  },
  mounted() {
    // localStorage에서 토큰을 확인하여 Vuex 상태 업데이트
    const token = sessionStorage.getItem('token');
    const adminId = sessionStorage.getItem('adminId')
    if (token) {
      this.$store.dispatch('login', {token, adminId});
    }
  },

};
</script>
